// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.scss
// module id = 822
// module chunks = 0